import React, { useEffect, useState } from "react";
import { url } from "../constants/url";

const ViewTeamMembers = ({ companyId }) => {
  const [companyData, setCompanyData] = useState(null);

  const fetchCompanyData = async () => {
    try {
      const response = await fetch(
        `${url}/api/company/fetch-company-members?companyId=${companyId}`
      );

      const data = await response.json();
      setCompanyData(data.data);
      console.log("Company Members Data:", data.data);
    } catch (error) {
      console.error("❌ Error fetching company data:", error);
    }
  };

  useEffect(() => {
    fetchCompanyData();
  }, []);

  if (!companyData) return <p>Loading...</p>;

  return (
    <>
      <h3>Admin Details</h3>
      <p><strong>Name:</strong> {companyData.createdBy?.name}</p>
      <p><strong>Email:</strong> {companyData.createdBy?.email}</p>

      {/* <h3>Approved By (Super Admin)</h3>
      <p><strong>Name:</strong> {companyData.approvedBy?.name}</p>
      <p><strong>Email:</strong> {companyData.approvedBy?.email}</p> */}

      <h3>Team Members</h3>
      <ul>
        {companyData.teamMembers?.map((m) => (
          <li key={m._id}>
            <strong>{m.userId?.name}</strong> — {m.userId?.email}
          </li>
        ))}
      </ul>
    </>
  );
};

export default ViewTeamMembers;
